import { render, staticRenderFns } from "./RequestTotp.vue?vue&type=template&id=047ae480&scoped=true"
import script from "./RequestTotp.vue?vue&type=script&lang=ts"
export * from "./RequestTotp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ae480",
  null
  
)

export default component.exports